import { useAIChat } from "@/Chat/ChatSidebar/AIChatContext";
import { ChatRecord } from "@/shared/domain/chat";
import { useChatsForUser } from "@/shared/domain/chat/hooks";

import styles from "./ChatHistoryView.module.css";

const ChatHistoryViewRow = ({
  chat,
  onClick,
}: {
  chat: ChatRecord;
  onClick: () => void;
}) => {
  return (
    <div className={styles.chatRow} onClick={onClick}>
      <p className={styles.chatTitle}>{chat.title || `Chat ${chat.chat_id}`}</p>
      <p className={styles.chatSubtitle}>
        {new Date(chat.created).toLocaleString()} - {chat.chat_id}
      </p>
    </div>
  );
};

export const ChatHistoryView = () => {
  const { handleHistoryChatClicked } = useAIChat();
  const chatsQuery = useChatsForUser();

  const chatHistory = chatsQuery.data?.items || [];

  if (chatsQuery.isLoading) {
    return (
      <div className={styles.mainContainer}>
        <div className={styles.centeringContainer}>
          <p>Loading chats...</p>
        </div>
      </div>
    );
  }

  if (chatsQuery.error) {
    return (
      <div className={styles.mainContainer}>
        <div className={styles.centeringContainer}>
          <p>Error loading chats: {chatsQuery.error.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.centeringContainer}>
        {chatHistory.length === 0 ? (
          <p>No chats yet!</p>
        ) : (
          chatHistory.map((chat) => (
            <ChatHistoryViewRow
              key={chat.chat_id}
              chat={chat}
              onClick={() => handleHistoryChatClicked(chat.chat_id)}
            />
          ))
        )}
      </div>
    </div>
  );
};
